import { BillOfMaterialRecord } from '../../../../../types/BillOfMaterial';
import { RecordFile } from '../../../../../types';
import React from 'react';
import AttachmentUpload from '../../../../../components/AttachmentUpload';
import BillOfMaterialInfoView from './BillOfMaterialInfoView';
import BillOfMaterialInfoTable from './BillOfMaterialInfoTable';

interface BillOfMaterialInfoContentProps {
  data?: BillOfMaterialRecord;
  attachments?: RecordFile[];
  /** Set together to allow adding/removing; omit any and the list stays read-only. */
  api?: string;
  recordId?: string;
  canEdit?: boolean;
}
const BillOfMaterialInfoContent: React.FC<BillOfMaterialInfoContentProps> = ({
  data,
  attachments,
  api,
  recordId,
  canEdit,
}) => {
  return (
    <>
      <div className={'w-9/12 space-y-4 h-[calc(84vh)] overflow-auto m'}>
        <div className={'p-4 rounded bg-white'}>
          <BillOfMaterialInfoView data={data} />
          <AttachmentUpload
          attachments={attachments}
          api={api}
          recordId={recordId}
          canEdit={canEdit}
        />

          <div>
            <span>Details</span>
            <BillOfMaterialInfoTable data={data?.details} />
          </div>
        </div>
      </div>
    </>
  );
};
export default BillOfMaterialInfoContent;
